<main id="login-page">
    <div *ngIf="!getUserName()" class="main-panel">
        <div class="row">
            <div class="col-lg-8 col-md-8 col-sm-12 login-col">
                <div class="login-wrap">
                    <ul>
                        <li>
                            <br>
                            <h3>Log in with Email</h3>
                            <form id="loginForm" (ngSubmit)="doLogin(loginForm)" #loginForm="ngForm">
                                <input class="form-control" ngModel id="Email" name="email" required email
                                    placeholder="email" type="text" value="">
                                <input class="form-control" ngModel id="Password" name="password" required
                                    placeholder="password" type="password" value="">
                                <button [disabled]="!loginForm.valid" class="btn btn-block" type="submit">log
                                    in</button>
                                <div class="margin-top-10">
                                    <a [routerLink]="['/forgotpasswordview']">Forgot Password?</a>
                                </div>
                            </form>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 ">
                <hr>
                <h4>Don't have an account? <a class="btn login-register-buttons"
                        [routerLink]="['/registerview']">Register</a> now</h4>
            </div>
        </div>
    </div>
    <div *ngIf="getUserName()" class="main-panel">
        <div class="row">
            <div class="col-sm-12 ">
                <hr>
                <h4>Welcome {{getUserName()}}. You are now logged in.</h4>
            </div>
        </div>
    </div>
</main>